import Analytics from '../services/analytics'

export const openMyFarmlands = () => {
  Analytics.page('https://account.farmlands.co.nz')
  window.open('https://account.farmlands.co.nz', '_blank')
}
